'use strict';

exports.Heading = require('./Heading');
exports.HeadingCaption = require('./HeadingCaption');